export default __webpack_public_path__ + "static/media/5.cfe9a039.jpg";